<template>
  <v-app dark class="bg-bgprimary">
    <div class="height-100 d-flex justify-center align-center">
      <EmEmptyState
        v-if="error.statusCode === 404"
        icon="mdi-robot-confused"
        title="404 Not Found"
        subtitle="The page you are looking for doesn't exist."
        btn-text="Go to home"
        :loading="loading"
        secondary-btn-text="Logout"
        @secondary-click="logout"
        @click="goToHome()"
      />
      <EmEmptyState
        v-else
        icon="mdi-cog"
        title="An unexpected error occurred"
        btn-text="Go to home"
        secondary-btn-text="Logout"
        :loading="loading"
        @secondary-click="logout"
        @click="goToHome()"
      >
        <template #subtitle>
          <div class="text-center">
            <EmBody1>
              If this error persists, please reach out to us at
              <EmCopySupportEmail />
            </EmBody1>
          </div>
          <EmErrorStack :show="showError" :error="error" />
        </template>
      </EmEmptyState>
    </div>
  </v-app>
</template>

<script setup>
import * as Sentry from '@sentry/browser'
const props = defineProps({
  error: { type: Object, default: null }
})
useHead({
  title: props.error.statusCode === 404 ? 'Not found' : 'Unexpected error'
})
const snackbar = useSnackbar()
const router = useRouter()
const { goToInboxOrHome } = useUserStore()
const loading = ref(false)
const logout = () => { router.push('/logout') }
const goToHome = async () => {
  try {
    loading.value = true
    await goToInboxOrHome()
  } catch (error) {
    Sentry.captureException(error)
    snackbar.error('An error occurred when trying to navigate to home.')
  } finally {
    loading.value = false
  }
}
onMounted(() => {
  Sentry.captureException(props.error)
})
</script>
